// extracted by mini-css-extract-plugin
export var displayImage = "TeamMemberCard-module--display-image--gsyoD";
export var logo = "TeamMemberCard-module--logo--YMeGf";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var tagline = "TeamMemberCard-module--tagline--LDUQx";
export var teamSectionHeading = "TeamMemberCard-module--team-section-heading--T0+dL";